import { FormattedMessage } from "react-intl";
import { Link } from 'react-router-dom';

export const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="bg-primary relative overflow-hidden">
			{/* Background decoration */}
			<div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />

			{/* Main Footer */}
			<div className="container-main py-12 md:py-16 relative">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
					{/* Brand */}
					<div className="lg:col-span-1">
						<img
							className="h-10 w-auto mb-5"
							src={`${process.env.PUBLIC_URL}/assets/efektivos_logo_white.png`}
							alt="Efektivos"
						/>
						<p className="text-body-sm text-white/60 mb-5 max-w-xs leading-relaxed">
							Tu aliado financiero en Guatemala. Préstamos rápidos, seguros y 100% digitales.
						</p>
						{/* Social Links */}
						<div className="flex items-center gap-3">
							<a
								href="https://www.facebook.com/gt.efektivos/"
								target="_blank"
								rel="noreferrer"
								className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-accent hover:text-white transition-all duration-300"
								aria-label="Facebook"
							>
								<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
									<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
								</svg>
							</a>
							<a
								href="https://www.instagram.com/efektivos/?hl=es"
								target="_blank"
								rel="noreferrer"
								className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-accent hover:text-white transition-all duration-300"
								aria-label="Instagram"
							>
								<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
									<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
								</svg>
							</a>
						</div>
					</div>

					{/* Links */}
					<div>
						<h4 className="text-body-md font-bold text-white mb-4">
							Legal
						</h4>
						<ul className="space-y-3">
							<li>
								<Link
									to="/privacy"
									className="text-body-sm text-white/60 hover:text-accent transition-colors inline-flex items-center gap-2 group"
								>
									<span className="w-1.5 h-1.5 bg-accent/50 rounded-full group-hover:bg-accent transition-colors" />
									<FormattedMessage id="APP.PRIVACY.POLICY.TITLE" />
								</Link>
							</li>
							<li>
								<Link
									to="/delete-account"
									className="text-body-sm text-white/60 hover:text-accent transition-colors inline-flex items-center gap-2 group"
								>
									<span className="w-1.5 h-1.5 bg-accent/50 rounded-full group-hover:bg-accent transition-colors" />
									Eliminar cuenta
								</Link>
							</li>
						</ul>
					</div>

					{/* Contact */}
					<div>
						<h4 className="text-body-md font-bold text-white mb-4">
							<FormattedMessage id="APP.NAV.CONTACT.LABEL" />
						</h4>
						<ul className="space-y-3">
							<li>
								<a
									href="mailto:info@efektivos.com"
									className="text-body-sm text-white/60 hover:text-accent transition-colors inline-flex items-center gap-2"
								>
									<svg className="w-4 h-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
									</svg>
									info@efektivos.com
								</a>
							</li>
							<li>
								<span className="text-body-sm text-white/60 inline-flex items-center gap-2">
									<svg className="w-4 h-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
									</svg>
									Guatemala, C.A.
								</span>
							</li>
						</ul>
					</div>

					{/* App Download */}
					<div>
						<h4 className="text-body-md font-bold text-white mb-4">
							Descarga la App
						</h4>
						<a
							href="https://play.google.com/store/apps/details?id=com.devstack.efektivos"
							target="_blank"
							rel="noreferrer"
							className="inline-flex items-center gap-3 px-4 py-3 bg-white/10 border border-white/10 rounded-xl text-white hover:bg-accent hover:border-accent transition-all duration-300 group"
						>
							<svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
								<path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
							</svg>
							<div className="text-left">
								<div className="text-caption text-white/60 group-hover:text-white/80">Disponible en</div>
								<div className="text-body-sm font-semibold">Google Play</div>
							</div>
						</a>
					</div>
				</div>
			</div>

			{/* Bottom Bar */}
			<div className="border-t border-white/10">
				<div className="container-main py-5">
					<div className="flex flex-col md:flex-row justify-between items-center gap-3">
						<p className="text-caption text-white/50">
							© {currentYear} Efektivos. Todos los derechos reservados.
						</p>
						<div className="flex items-center gap-2 text-caption text-white/40">
							<span>Hecho con</span>
							<svg className="w-4 h-4 text-accent" fill="currentColor" viewBox="0 0 20 20">
								<path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
							</svg>
							<span>en Guatemala</span>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};
